import { render, staticRenderFns } from "./beneficio-component.vue?vue&type=template&id=5359ffe0&"
import script from "./beneficio-component.vue?vue&type=script&lang=ts&"
export * from "./beneficio-component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins-hml/workspace/pracessivel-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5359ffe0')) {
      api.createRecord('5359ffe0', component.options)
    } else {
      api.reload('5359ffe0', component.options)
    }
    module.hot.accept("./beneficio-component.vue?vue&type=template&id=5359ffe0&", function () {
      api.rerender('5359ffe0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/component/beneficio-component.vue"
export default component.exports